import React, { FC, useState, useEffect, useRef } from "react";
import { TExpandableOverlayGalleryProps } from "../../types/ExpandableOverlay";
import OverlayCarouselArrow from "./OverlayCarouselArrow";
import { BreakpointsInPx } from "../../../../constants/breakpoints.constants";
import useMediaQuery from "../../../../lib/custom-hooks/useMediaQuery";
import "./styles.scss";

const ExpandableOverlayGallery: FC<TExpandableOverlayGalleryProps> = ({
  slides,
  title,
  description,
}) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const SlideSectionRef = useRef<HTMLDivElement>(null);
  const isWide = useMediaQuery("(min-width: 768px)");

  useEffect(() => {
    function resizeHandler() {
      if (SlideSectionRef && SlideSectionRef.current) {
        const slideSectionDim = SlideSectionRef.current?.getBoundingClientRect();
        if (slideSectionDim.width - slides.length * 176 > 0) {
          SlideSectionRef.current.style.justifyContent = "center";
          return;
        }
      }
    }
    resizeHandler();
    window && window.addEventListener("resize", resizeHandler);
    return () => window && window.removeEventListener("resize", resizeHandler);
  }, [SlideSectionRef]);

  useEffect(() => {
    if (!isWide) return;
    if (SlideSectionRef && SlideSectionRef.current) {
      const slideSectionDim = SlideSectionRef.current.getBoundingClientRect();
      if (slideSectionDim.width - slides.length * 176 > 0) {
        return;
      }
      const maxNoofCards = Math.floor(slideSectionDim.width / 176);
      let moveBy = (currentCardIndex + 1 - maxNoofCards) * 176;

      if (currentCardIndex + 1 === slides.length) {
        const totalWidth = 176 * slides.length - 8;
        moveBy = totalWidth - slideSectionDim.width;
      }

      if (moveBy > 0) {
        SlideSectionRef.current.style.setProperty(
          "--expanded-overlay-slide-move-by",
          `-${moveBy}px`
        );
      } else {
        SlideSectionRef.current.style.setProperty(
          "--expanded-overlay-slide-move-by",
          "0px"
        );
      }
    }
  }, [currentCardIndex, SlideSectionRef]);

  const moveLeft = () => {
    setCurrentCardIndex((index) => (index > 0 ? index - 1 : index));
  };

  const moveRight = () => {
    setCurrentCardIndex((index) =>
      index + 1 < slides.length ? index + 1 : index
    );
  };

  const goToCard = (index) => {
    setCurrentCardIndex(index);
  };

  return (
    <div className="series-overview-expandable-overlay__white-box series-overview-expandable-overlay__carousel-box">
      <div
        className={
          isWide ? "series-overview-expandable-overlay__main-section" : ""
        }
      >
        {isWide && (
          <OverlayCarouselArrow direction="previous" onClick={moveLeft} />
        )}
        <div className="series-overview-expandable-overlay__focus-image-wrapper">
          {slides?.map((slide, index, arr) => (
            <div
              className={`
                  series-overview-expandable-overlay__focus-image
                  ${
                    index < currentCardIndex
                      ? "series-overview-expandable-overlay__focus-image--move-left"
                      : ""
                  }
                  `}
              style={{ zIndex: arr.length - index }}
              key={index}
            >
              <picture className="">
                <source
                  srcSet={slide.bigthumbnail}
                  media={`(min-width: ${BreakpointsInPx.md})`}
                />
                <source
                  srcSet={slide?.thumbnail}
                  media={`(min-width: ${BreakpointsInPx.xs})`}
                />
                <img loading="lazy" src={slide?.bigthumbnail} alt={slide.alt} />
              </picture>
            </div>
          ))}
        </div>
        {isWide && (
          <OverlayCarouselArrow direction="next" onClick={moveRight} />
        )}
      </div>
      <div
        className={
          !isWide
            ? "series-overview-expandable-overlay__slide-section-wrapper series-overview-expandable-overlay__modal-gray-wrapper series-overview-expandable-overlay__modal-gray-wrapper--gallery"
            : "series-overview-expandable-overlay__slide-section-wrapper"
        }
      >
        <div
          className="series-overview-expandable-overlay__slide-section"
          ref={SlideSectionRef}
        >
          {slides?.map((slide, index) => (
            <div
              className="series-overview-expandable-overlay__slide-image-wrapper"
              onClick={() => goToCard(index)}
              key={index}
            >
              <div
                className={`series-overview-expandable-overlay__slide-image-blur ${
                  currentCardIndex === index
                    ? "series-overview-expandable-overlay__slide-image-blur--deactivate"
                    : ""
                }`}
              />
              <div
                className={
                  currentCardIndex === index
                    ? "series-overview-expandable-overlay__slide-highlight-bar"
                    : ""
                }
              />

              <picture className="series-overview-expandable-overlay__slide-image--fixed-aspect-ratio">
                <source
                  media={`(min-width: ${BreakpointsInPx.md})`}
                  srcSet={slide.thumbnail}
                  style={{ zIndex: 0 }}
                  className={"desktop"}
                />
                <source
                  media={`(min-width: ${BreakpointsInPx.xs})`}
                  srcSet={slide.bigthumbnail}
                  style={{ zIndex: 0 }}
                  className={"mobile"}
                />
                <img
                  src={slide.full}
                  alt={slide.alt}
                  style={{ zIndex: 0 }}
                  className={""}
                  width={84}
                  height={48}
                />
              </picture>
            </div>
          ))}
        </div>
        {/* {!isWide && (
          <>
            <div className="series-overview-expandable-overlay__modal-title series-overview-expandable-overlay__modal-title--gallery">
              {title}
            </div>
            <div className="series-overview-expandable-overlay__modal-description series-overview-expandable-overlay__modal-description--gallery">
              {description}
            </div>
          </>
        )} */}
      </div>
    </div>
  );
};

export default ExpandableOverlayGallery;
